<template>
  <div class="animated fadeIn list-of-po">
    <b-card>
      <div slot="header">Bread Request List
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <!-- <b-button variant="primary mr-1" @click="additional">Additional</b-button> -->
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="copyConfirm" >Copy</b-button>
          <b-button variant="primary mr-1" @click="approvalConfirm" >Send Approval</b-button>
          <!-- <b-button variant="primary mr-1" @click="approvalConfirmAdditional" >Send Approval Additional</b-button> -->
          <!-- <b-button variant="primary mr-1" @click="deleteConfirm" :disabled="disabledDelete">Delete</b-button> -->
          <!-- <b-dropdown text="Print" variant="primary mr-1" >
            <b-dropdown-item @click="print">Supplier PO</b-dropdown-item>
            <b-dropdown-item @click="printdo" >Checker/DO</b-dropdown-item>
            <b-dropdown-item @click="printwholesaleinv" >Invoice Wholesale</b-dropdown-item>
          </b-dropdown>
          <b-dropdown text="Export ForeCast" variant="primary mr-1" >
            <b-dropdown-item @click="showFrmVendor=true">Vendor</b-dropdown-item>
            <b-dropdown-item @click="showFrmCustomer=true" >Customer</b-dropdown-item>
          </b-dropdown>
          <b-dropdown text="Receiving" variant="primary mr-1" >
            <b-dropdown-item @click="receivingSupplier">Supplier</b-dropdown-item>
            <b-dropdown-item @click="receivingCustomer" >Customer</b-dropdown-item>
          </b-dropdown> -->
          <b-button variant="primary mr-1" @click="exportxlsRequest()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <!-- <b-row>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Order Number</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.nomor" placeholder="Order No. (% for wildcard)"></b-form-input>
                    </b-input-group>
                  </b-col>
            </b-row>           -->
            <b-row>
              <b-col lg="10">
                  <b-input-group >
                    <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
            </b-row>   
            <b-row>
                <b-col lg="10">
                  <b-input-group>
                    <b-input-group-prepend><label>Vendor</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.vendorinfo"></b-form-input>
                    <b-input-group-append class="mr-2">
                      <b-btn variant="primary" @click="lkuVendorShow=true"> <i class="fa fa-search"></i></b-btn>
                    </b-input-group-append>
                    <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.CustName" @change="customerChange" :disabled="viewOption!='Lines'"></b-form-input>
                    <b-input-group-append>
                      <b-btn variant="primary" @click="lkuCustShow=true" :disabled="viewOption!='Lines'"> <i class="fa fa-search"></i></b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
            </b-row>         
        </b-col>
        <b-col lg="5">


          <b-row>
              <b-col lg="12">
                <b-input-group v-if="viewOption=='Lines'">
                  <b-input-group-prepend><label>Item Name/Desc.</label></b-input-group-prepend>
                  <b-form-input v-model="tblData.itemname" placeholder="Item Name" @change="itemChange"></b-form-input>
                  <b-input-group-append class="mr-2">
                  <b-btn variant="primary" @click="lkuItemShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
                  <b-input-group-prepend><label style="width:80px !important;">Issued By</label></b-input-group-prepend>
                  <b-form-input v-model="tblData.createby" placeholder="Issued By"></b-form-input>
                </b-input-group>
                <b-input-group v-else>
                  <b-input-group-prepend><label>Item Name/Desc.</label></b-input-group-prepend>
                  <b-form-input v-model="tblData.itemname" placeholder="Item Name" @change="itemChange" disabled></b-form-input>
                  <b-input-group-append class="mr-2">
                  <b-btn variant="primary" @click="lkuItemShow=true" disabled>
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
                  <b-input-group-prepend><label style="width:80px !important;">Issued By</label></b-input-group-prepend>
                  <b-form-input v-model="tblData.createby" placeholder="Issued By"></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>   
            <b-row>
                <b-col lg="10">
                  <b-input-group class="mt-1 mb-1">
                    <b-input-group-prepend><label class='label-input-group'>View Option</label></b-input-group-prepend>
                    <b-form-radio-group  v-model="viewOption" class="mt-1">
                        <b-form-radio v-model="viewOption" value="Header">Header/Summary</b-form-radio>
                        <b-form-radio v-model="viewOption" value="Lines">Line/Items</b-form-radio>
                    </b-form-radio-group> 
                    <b-input-group-append>
                          <b-button variant="success" size="sm" class="ml-3" @click="search()"><i class="fa fa-refresh"></i> Apply Filter</b-button>
                          <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()">Clear Filter</b-button>
                    </b-input-group-append>
                </b-input-group>
                  </b-col>
            </b-row>
            
            
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined small 
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <!-- <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print</b-dropdown-item> -->
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>        
        <template v-slot:cell(tgldelivery)="data">
          {{ data.item.tgldelivery | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(nilainett)="data">
          {{data.item.nilainett | numFormat}}
        </template>
        <template v-slot:cell(nilaippn)="data">
          {{data.item.nilaippn | numFormat}}
        </template>
        <template v-slot:cell(nilaidue)="data">
          {{data.item.nilaidue | numFormat}}
        </template>
        <template v-slot:cell(nilaiduereceiving)="data">
          {{data.item.nilaiduereceiving | numFormat}}
        </template>
        <template v-slot:cell(totitemreceived)="data">
          <span v-if="(data.item.totitemreceived>0)"> {{data.item.totitemreceived | numFormat}} of {{data.item.totitemordered | numFormat}} items </span>
        </template>

        
        <template v-slot:cell(status_approval)="data">
          <span v-if="(data.item.status_approval == 'Approved' || data.item.status_approval == 'Rejected')" :class="data.item.status_approval=='Approved'?'alert-success navbar-link p-1':'alert-danger navbar-link p-1'" style="cursor: pointer;">
            <span>{{data.item.status_approval}}</span>
          </span>
          <span v-else>
            <span>{{data.item.status_approval}}</span>
          </span>
          <!-- <span v-if="(data.item.issuccess == 1)" :class="data.item.issuccess=='1'?'alert-success navbar-link p-1':'alert-danger navbar-link p-1'" style="cursor: pointer;">
            <span>Approved</span>
          </span>
          <span v-else>
            <span></span>
          </span> -->
        </template>



      </b-table>
      <b-row class="mt-2">
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total | numFormat}} entries
          </div>
        </b-col>
        <b-col cols="2" >
            <b-input-group >
                <b-input-group-prepend><span  class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
            </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Are you sure about doing this?</p>
      </b-modal>
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal> 
        <b-modal v-model="lkuCustShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
          <lku-cust @click="onSelectCust"></lku-cust>
        </b-modal>       
        <b-modal v-model="lkuVendorShow" size="lg" :hide-footer="true" title="List of Vendor" :centered="true">
            <lku-supplier @click="onSelectLkuVendor"></lku-supplier>
        </b-modal> 
        
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item" :centered="true">
            <lku-item @click="onSelectLkuItem" jasa="0" isactive="1" :formdata="itemList"></lku-item>
        </b-modal> 
 
    <b-modal v-model="showFrmVendor" header-bg-variant="primary" size="md" title="Forecast- Vendor" :centered="true" @ok="exportFcVendor" ok-title="Export">
        <b-row >
          <b-col>
            <b-input-group >
              <b-input-group-prepend><label style="width:107px !important;">Supplier/Vendor</label></b-input-group-prepend>
              <b-form-input v-model="forecastvendor.vendorinfo" placeholder="Supplier/Vendor"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuVendorShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group >
            <b-input-group >
              <b-input-group-prepend><label style="width:107px !important;">Date range</label></b-input-group-prepend>
                <b-form-input v-model="forecastvendor.tgl1" type="date" ></b-form-input>
                <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                <b-form-input v-model="forecastvendor.tgl2" type="date" ></b-form-input>
            </b-input-group >
          </b-col>
      </b-row>
    </b-modal>

    <b-modal v-model="showFrmCustomer" header-bg-variant="primary" size="md" title="Forecast- Customer" :centered="true" @ok="exportFcCustomer" ok-title="Export">
        <b-row >
          <b-col>
            <b-input-group >
              <b-input-group-prepend><label style="width:107px !important;">Customer/Group</label></b-input-group-prepend>
              <b-form-input v-model="forecastcustomer.customer" placeholder="Customer or Group/Holding"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuCustomerShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group >
            <b-input-group >
              <b-input-group-prepend><label style="width:107px !important;">Date range</label></b-input-group-prepend>
                <b-form-input v-model="forecastcustomer.tgl1" type="date" ></b-form-input>
                <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                <b-form-input v-model="forecastcustomer.tgl2" type="date" ></b-form-input>
            </b-input-group >
          </b-col>
      </b-row>
    </b-modal>

    <b-modal v-model="showApprovalConfirm" header-bg-variant="primary"  title="Send Approval Form" size="md" :centered="true" hide-footer>
          <b-row>
              <b-col md="12"> 
                <b-input-group >
                  <b-input-group-prepend><label style="width:107px !important;">Request Date</label></b-input-group-prepend>
                  <b-form-input v-model="model.tgl1" type="date" :state="!$v.model.tgl1.$error" @change="dateFromChange(model.tgl1)"></b-form-input>
                  <b-form-checkbox
                  class="ml-1 mt-2 text-left"
                  v-model="useperiode"
                  value=1 unchecked-value=0
                  @change="useChange()" ><i>Use Periode</i></b-form-checkbox>
              </b-input-group >
              </b-col>
          </b-row >
          <b-row>
              <b-col md="12"> 
                <b-input-group >
                  <b-input-group-prepend v-show="collapsed"><span class="input-group-text" style="width:107px !important;">until</span></b-input-group-prepend>
                  <b-form-input v-model="model.tgl2" type="date" :state="!$v.model.tgl2.$error" v-show="collapsed" style="margin-right:106px;"></b-form-input>  
              </b-input-group >
              </b-col>
          </b-row>
          <b-row class="justify-content-center mt-1" >
              <b-button variant="primary" @click="approval"><i class="fa fa-paper-plane"></i> Send Approval</b-button>
              <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
          </b-row>
      </b-modal>

      <b-modal v-model="showApprovalConfirmAdditional" header-bg-variant="primary"  title="Send Approval Additional Form" size="md" :centered="true" hide-footer>
          <b-row>
              <b-col md="12"> 
                <b-input-group >
                  <b-input-group-prepend><label style="width:107px !important;">Request Date</label></b-input-group-prepend>
                  <b-form-input v-model="model.tgl1" type="date" :state="!$v.model.tgl1.$error" @change="dateFromChange(model.tgl1)"></b-form-input>
                  <b-form-checkbox
                  class="ml-1 mt-2 text-left"
                  v-model="useperiode"
                  value=1 unchecked-value=0
                  @change="useChange()" ><i>Use Periode</i></b-form-checkbox>
              </b-input-group >
              </b-col>
          </b-row >
          <b-row>
              <b-col md="12"> 
                <b-input-group >
                  <b-input-group-prepend v-show="collapsed"><span class="input-group-text" style="width:107px !important;">until</span></b-input-group-prepend>
                  <b-form-input v-model="model.tgl2" type="date" :state="!$v.model.tgl2.$error" v-show="collapsed" style="margin-right:106px;"></b-form-input>  
              </b-input-group >
              </b-col>
          </b-row>
          <b-row class="justify-content-center mt-1" >
              <b-button variant="primary" @click="approvalAdditional"><i class="fa fa-paper-plane"></i> Send Approval Additional</b-button>
              <b-button variant="secondary" class="ml-1" @click="showApprovalConfirmAdditional=false" > <i class="fa fa-close"></i> Close</b-button>
          </b-row>
      </b-modal>

      <b-modal v-model="showCopyConfirm" header-bg-variant="primary"  title="Copy Request Form" size="lg" :centered="true" hide-footer>
          <b-row>
              <b-col md="12"> 
                <b-input-group >
                  <b-input-group-prepend><label style="width:120px !important;">Request Date</label></b-input-group-prepend>
                  <b-form-input v-model="modelcopy.tglrequest" type="date" :state="!$v.modelcopy.tglrequest.$error"></b-form-input>
              </b-input-group >
              <b-input-group >
                  <b-input-group-prepend><label style="width:120px !important;">Copy From Date</label></b-input-group-prepend>
                  <b-form-input v-model="modelcopy.tglcopy" type="date" :state="!$v.modelcopy.tglcopy.$error"></b-form-input>
              </b-input-group >
              </b-col>
          </b-row >  
          <b-row class="justify-content-center mt-1" >
              <b-button variant="primary" @click="copy"><i class="fa fa-paper-plane"></i> Copy</b-button>
              <b-button variant="secondary" class="ml-1" @click="showCopyConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
          </b-row>
      </b-modal> 

  </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import procure from "../../apis/bakeryorder";
import dropdown from "../../data/dropdown";
import lkuSupplier from "../lookup/lkuSupplier";
import lkuCustomer from "../lookup/lkuCustomer";
import lkuItem from "../lookup/lkuItemLazzy";
import lkuCust from "../lookup/lkuCustomer";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";
toastr.init();

export default {
  components: {Loading, lkuSupplier,lkuCustomer, lkuItem, lkuCust},
  mixins: [validationMixin],
  validations: {
        forecastcustomer: {
            customer_id: { required },
            tgl1: { required },
            tgl2: { required }
        },
        forecastvendor: {
            vendor_id: { required },
            tgl1: { required },
            tgl2: { required }
        },
        model: {
            tgl1: { required },
            tgl2: { required }  
        },
        modelcopy: {
            tglrequest: { required },
            tglcopy: { required }   
        },

  }, 
  data() {
    return {
      showFilter: true,
      showDelConfirm: false,
      showFrmVendor:false,
      lkuVendorShow:false,
      forecastvendor:{vendor_id:'', tgl1:'', tgl2:''},
      showFrmCustomer:false,
      showApprovalConfirm: false,
      showApprovalConfirmAdditional: false,
      showCopyConfirm: false,
      forecastcustomer:{customer_id:'', tgl1:'', tgl2:''},
      model:{tgl1:'', tgl2:''},
      modelcopy:{tglrequest:'', tglcopy: ''},
      useperiode:0,
      collapsed: false,
      lkuCustomerShow:false,
      lkuCustShow: false,
      lkuItemShow:false,
      disabledCloseVoid:true,
      disabledDelete:false,
      isLoading:false,
      showReport:false,
      viewOption:'Header',
      reportUrl: `${location.origin}/#load`,
        items: [],
      tblData: {
        CustName:'',
        itemname:'',
        status:"",
        postgroup:"",
        page: 1,
        limit: 15,
        total: 0,
        tgl1:moment().subtract(1, 'months').format('YYYY-MM-DD'),
        tgl2:moment().format('YYYY-MM-DD'),
        tglrequest: moment().format('YYYY-MM-DD'),
        sortBy: 'tgldelivery',//customer_id
        sortDesc: true,
        DimCol:'Dim1',
        outstand:'',
        vendorinfo:'',vendor_id:''
      },
      itemList:{},
      limit:15,
      pagination: false,      
      tblFields: [
        // {
        //   key: "action",
        //   label: "",
        //   thStyle: "width:30px",
        //   thClass: "text-center",
        // },
          {
            key: "tgldelivery",
            thStyle: "width:90px",
            label: "Request Date",
            sortable: true
          },
          {
            key: "customer_group",
            label: "Customer Group",
            sortable: true
          },
          {
            key: "qtyOrder",
            label: "Qty Summary",
            thStyle: "width:200px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "status_approval",
            label: "Status Approval",
            thStyle: "width:200px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "orderno",
            label: "PO No.",
            thStyle: "width:200px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "vendor",
            label: "Vendor",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "createby",
            label: "Issued By",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          }
        ],
      model:{},
      modelcopy:{},
      postGroups:[],
      approvalStatus : dropdown.approvalStatus,
      outstandSlct : dropdown.openClose,
      forecastcustomer:{
        closeVoid:'closed',
        closevoidnote:'',
        options: [
          { text: 'Closed', value: 'closed' },
          { text: 'Void', value: 'void' },
        ]
      },
      forecastvendor:{trackStatus:''},
      showStatusUpdate:false,      
    };
  },
  computed: {
    invalidFcCustomer() {
      this.$v.forecastcustomer.$touch();
      return this.$v.forecastcustomer.$invalid;
    },
    invalidFcVendor() {
      this.$v.forecastvendor.$touch();
      return this.$v.forecastvendor.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidModelcopy() {
      this.$v.modelcopy.$touch();
      return this.$v.modelcopy.$invalid;
    },
  },
  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },
    
    viewOption : function(newval) {
      if (newval=='Header') {
        this.tblFields= [
        {
          key: "action",
          label: "",
          thStyle: "width:30px",
          thClass: "text-center",
        },
          {
            key: "tgldelivery",
            thStyle: "width:90px",
            label: "Request Date",
            sortable: true
          },
          {
            key: "customer_group",
            label: "Customer Group",
            sortable: true
          },
          {
            key: "qtyOrder",
            label: "Qty Summary",
            thStyle: "width:200px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "status_approval",
            label: "Status Approval",
            thStyle: "width:200px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "orderno",
            label: "PO No.",
            thStyle: "width:200px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "vendor",
            label: "Vendor",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "createby",
            label: "Issued By",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          }
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          this.tblFields.push({
            key: `${dims[i].value}Txt`,
            label: dims[i].text,
            sortable: true
          });
        }
      } else {
        this.tblData.CustName=  '';

        this.tblFields= [
        {
          key: "action",
          label: "",
          thStyle: "width:30px",
          thClass: "text-center",
        },
          {
            key: "tgldelivery",
            thStyle: "width:90px",
            label: "Request Date",
            sortable: true
          },
          {
            key: "custinfo",
            label: "Customer",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "iteminfo",
            thStyle: "width:300px",
            label: "Item",
            sortable: true
          },
           {
            key: "itemcategory",
            thStyle: "width:300px",
            label: "Item Category",
          },
          {
            key: "qtyOrder",
            label: "Qty Order",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "status_approval",
            label: "Status Approval",
            thStyle: "min-width:150px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "orderno",
            label: "PO No.",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "vendor",
            label: "Vendor",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "createby",
            label: "Issued By",
            thStyle: "width:110px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          }
        ];
      }
      
      let newFields = [];
      this.tblFields.map((data,index)=>{
        if(!data.hide){
          newFields.push(data);
        }
      })
      this.tblFields = newFields;
      this.refresh();
    },

  },  
  methods: {
    onSelectLkuCustomer: async function (_selected) {
        this.forecastcustomer.customer_id = _selected.customer_id;
        this.forecastcustomer.CustCode = _selected.CustCode;
        this.forecastcustomer.CustName = _selected.CustName;
        this.forecastcustomer.customer = `${_selected.CustName} | ${_selected.CustCode}`;
        this.lkuCustomerShow=false;
    },    
    onSelectLkuVendor: async function (_selected) {
        this.forecastvendor.vendorinfo = _selected.vendor_code.trim() + ' | ' + _selected.vendor_name.trim();
        this.forecastvendor.vendor = _selected.vendor_code;
        this.forecastvendor.vendor_id = _selected.vendor_id;

        this.tblData.vendorinfo = _selected.vendor_code.trim() + ' | ' + _selected.vendor_name.trim();
        this.tblData.vendor = _selected.vendor_code;
        this.tblData.vendor_id = _selected.vendor_id;

        this.lkuVendorShow=false;
    },
    onSelectCust(_selected) {
      this.tblData.CustName = _selected.CustName;
      this.tblData.customer_id = _selected.customer_id;
      this.tblData.customerinfo = `${_selected.CustCode} | ${_selected.CustName}`;
      this.lkuCustShow = false;
    },
    onSelectLkuItem: function (lkuData) {
        this.itemList=lkuData;
        this.tblData.itemno = lkuData.selected.itemno;
        this.tblData.itemcode = lkuData.selected.itemcode;
        this.tblData.itemname = lkuData.selected.itemname;
        this.lkuItemShow=false;
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.polist) {
            this.tblData[key] = filter.polist[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.polist.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.polist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=false; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  let list =[];
                  if (this.viewOption=='Header') {
                      list = await procure.listrequestheader(this.tblData);
                  } else {
                      if (this.tblData.sortBy=='custinfo') this.tblData.sortBy='CustName'
                      if (this.tblData.sortBy=='iteminfo') this.tblData.sortBy='itemname'
                      list = await procure.listrequest(this.tblData);
                  }
                  list.map(data=>{
                    data.custinfo = `${data.CustCode} | ${data.CustName}`;
                    data.iteminfo = `${data.itemcode} | ${data.itemname}`;
                  });
                  //console.log('list',list);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              let list =[];
              if (this.viewOption=='Header') {
                  list = await procure.listrequestheader(this.tblData);
              } else {
                  list = await procure.listrequest(this.tblData);
              }
              //this.viewOption='Header';
              list.map(data=>{
                data.custinfo = `${data.CustCode} | ${data.CustName}`;
                data.iteminfo = `${data.itemcode} | ${data.itemname}`;
              });
              //console.log("#list: ", list);
              this.pagination=true;
              this.isLoading=false;
              return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }
    },

    useChange: function (val) {
      if (this.useperiode == 0) {
        this.collapsed = true;
      }else{
        this.collapsed = false;
      }
      this.refresh();
      this.model.tgl2 = this.model.tgl1;
    },

    dateFromChange: function (val) {
        if(val!=''){
          this.refresh();
          this.model.tgl2 = val;
        }
    },
    
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.vendor= '';
        this.tblData.createby= '';
        this.tblData.itemname=  '';
        this.tblData.uraian=  '';
        this.tblData.CustName=  '';
        this.tblData.requestno=  '';
        this.tblData.postgroup=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    saveFilter() {
      const keys = ['uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2','status', 'nomor', 'vendor', 'createby', 'requestno', 'postgroup', 'item', 'status','outstand'];
      let filtered = false;
      const polist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              polist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          polist.page=this.tblData.page;
          polist.limit=this.tblData.limit;
          polist.sortBy=this.tblData.sortBy;
          polist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.polist=polist;
          this.$store.commit("filter", filter);
      }
    },    
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowApproval(record) {
      this.rowClicked(record);
        this.approvalConfirm();        
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },
    add(){
      this.saveFilter();
      router.push({name :'bakery.requestfrm'});
    },
    additional(){
      this.saveFilter();
      router.push({name :'bakery.requestaddfrm'});
    },
    edit: function() {
        // if (this.model.requestkey) {
        // this.saveFilter();
        //   router.push({name :'bakery.requestfrm', params: { requestkey: this.model.requestkey,customer_id:this.model.customer_id,tgldelivery:this.model.tgldelivery}});
        // } else {
        //     toastr.warn('Please select a row that want to be Edit!');
        // }
        if (this.model.tgldelivery) {
          this.saveFilter();
          router.push({name :'bakery.requestfrm', params: {tgldelivery:this.model.tgldelivery, customer_group: this.model.customer_group}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },

    customerChange: function () {
        this.tblData.customer_id = '';
    },
    itemChange: function () {
        this.tblData.itemno = '';
    },

    approvalConfirm: async function () {
                this.showApprovalConfirm = true;
    },
    approvalConfirmAdditional: async function () {
                this.showApprovalConfirmAdditional = true;
    },

    approval: async function(evt){
        evt.preventDefault()
          if (this.invalidModel) {
              console.log('validation : ', this.$v.model);
              console.log('frmdata obj : ',this.model);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
          } else {
            try {
                this.showApprovalConfirm = false;
                this.isLoading=true;
                const resp = await procure.approval(this.model);
                this.refresh();
                this.isLoading=false;
                if (resp.message) {
                    toastr.success(resp.message,'warning',10000);
                }
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
          }
    },

    approvalAdditional: async function(evt){
        evt.preventDefault()
          if (this.invalidModel) {
              console.log('validation : ', this.$v.model);
              console.log('frmdata obj : ',this.model);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
          } else {
            try {
                this.showApprovalConfirmAdditional = false;
                this.isLoading=true;
                const resp = await procure.approvalAdditional(this.model);
                this.refresh();
                this.isLoading=false;
                if (resp.message) {
                    toastr.success(resp.message,'warning',10000);
                }
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
          }
    },

    copyConfirm: async function () {
                this.showCopyConfirm = true;
                this.modelcopy.tglrequest= moment().format('YYYY-MM-DD');
    }, 

    copy: async function(evt){
        evt.preventDefault()
          if (this.invalidModelcopy) {
              console.log('validation : ', this.$v.modelcopy);
              console.log('frmdata obj : ',this.modelcopy);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
          } else {
            try {
                this.showCopyConfirm = false;
                this.isLoading=true;
                const resp = await procure.copy(this.modelcopy);
                this.isLoading = false;
                this.refresh();
                if (resp) {
                    toastr.success(resp,'INFO!',10000);
                }else{
                    toastr.warning(resp,'WARNING!',10000);
                }
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
          }
    },

    receivingSupplier() {
        if (this.model.pohdrkey) {
          this.saveFilter();
          router.push({name :'bakery.receivingsupplierfrm', params: { pohdrkey: this.model.pohdrkey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    receivingCustomer() {
        if (this.model.pohdrkey) {
          this.saveFilter();
          router.push({name :'bakery.receivingcustomerfrm', params: { pohdrkey: this.model.pohdrkey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.requestkey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await procure.removerequest(this.model);
        this.refresh();
        // const index= this.items.findIndex(r => (r.pohdrkey==this.model.pohdrkey));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    rowClicked(record, index) {
      if( record.status === '111' ){
        this.disabledDelete = true;
        this.disabledCloseVoid   = false;
      }else{
        this.disabledDelete = false;
        this.disabledCloseVoid   = true;
      }

      // if (this.model.pohdrkey == record.pohdrkey) {
      //     this.edit();
      // } else {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      // }
    },
    
    print: async function()
    {
      if (this.model.pohdrkey) {
          this.isLoading=true;
          try {
              this.reportUrl= await procure.print(this.model);
              this.showReport=true;
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printdo: async function()
    {
      if (this.model.pohdrkey) {
          this.isLoading=true;
          try {
              this.reportUrl= await procure.printdo(this.model);
              this.showReport=true;
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },  
    printwholesaleinv: async function()
    {
      if (this.model.pohdrkey) {
          this.isLoading=true;
          try {
              this.reportUrl= await procure.printwholesaleinv(this.model);
              this.showReport=true;
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },       
    exportFcVendor: async function(evt) {
      evt.preventDefault()
      if (this.invalidFcVendor) {
          console.log('validation : ', this.$v.forecastvendor);
          console.log('frmdata obj : ',this.forecastvendor);
          toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      } else {
          try {
            this.isLoading=true;
              this.forecastvendor.tgl1 = moment(this.forecastvendor.tgl1).format('YYYY-MM-DD');
              this.forecastvendor.tgl2 = moment(this.forecastvendor.tgl2).format('YYYY-MM-DD');
              const response = await procure.exportFcVendor(this.forecastvendor);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'ForeCast_order_supplier.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);

            this.isLoading=false;    
          } catch (error) {
              this.isLoading=false;            
              console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }        
          }
      }
    },    
    exportFcCustomer: async function(evt) {
      evt.preventDefault()
      if (this.invalidFcCustomer) {
          console.log('validation : ', this.$v.forecastcustomer);
          console.log('frmdata obj : ',this.forecastcustomer);
          toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      } else {
          try {
              this.isLoading=true;
              this.forecastcustomer.tgl1 = moment(this.forecastcustomer.tgl1).format('YYYY-MM-DD');
              this.forecastcustomer.tgl2 = moment(this.forecastcustomer.tgl2).format('YYYY-MM-DD');
              const response = await procure.exportFcCustomer(this.forecastcustomer);
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'customer_order_summary.xlsx');
              document.body.appendChild(link);
              link.click();
              this.isLoading=false;    
          } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
          }
      }
    },      
    exportxlsRequest: async function() {
        this.isLoading=true;
        try {
            let response;
            if (this.viewOption=='Header') {
              response = await procure.exportxlsRequestHeader(this.tblData);
            } else {
              response = await procure.exportxlsRequest(this.tblData);
            }
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'bread_request_list.xlsx');
            document.body.appendChild(link);
            link.click();
            this.isLoading=false;    
        } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
        }
    },    
    close(){
        // router.push({name:'procurement.home'});
          router.push("home");
    }

  }
};
</script>
